import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import WpDynamicTable from "../../Components/WhatsappTable/WpDynamicTable";
import { fetchAllClients } from "../../Redux/WhatsappSlice/Client";
import { fetchDocumentLinkAll } from "../../Redux/WhatsappSlice/DocumentLinkSetup";
import { fetchTemplates } from "../../Redux/WhatsappSlice/Template";
import { fetchWpSetupAll } from "../../Redux/WhatsappSlice/WhatsappApiSetup";
import {
  DeleteClientRegistration,
  fetchAllWpRegistration,
  UpdateClientRegistration,
} from "../../Redux/WhatsappSlice/WhatsAppRegistration";
import Loader from "../../Components/Loader/Loader";

const View_WpRegistration = () => {
  const dispatch = useDispatch();

  const { AllClients } = useSelector((state) => state.Client);
  const { WpSetupData } = useSelector((state) => state.WpApiSetup);
  const { DocumentLinks } = useSelector((state) => state.DocumentLinkSetup);
  const { TemplateData } = useSelector((state) => state.Template);
  const { WpRegistrationList } = useSelector((state) => state.WpRegistration);

  // const [searchText, setSearchText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editingData, setEditingData] = useState(null);

  const [formData, setFormData] = useState({
    WhaClientName: "",
    UserName: "",
    Password: "",
    WhatsAppOffcialWa: "",
    DocLink: "",
    Templates: [],
    WhaCount: 0,
    WhaBalCount: 0,
    IsAdmin: false,
    IsActive: false,
    IsOWNWhatsapp: false,
    CheckConnection: false,
    Database: "",
    Port: "",
    FolderName: "",
    WhatsappBot: false,
    WappNo: "",
    APIToken: "",
    PhoneNoID: "",
    VerifyToken: "",
    Server: "",
  });

  useEffect(() => {
    dispatch(fetchAllClients());
    dispatch(fetchWpSetupAll());
    dispatch(fetchDocumentLinkAll());
    dispatch(fetchTemplates());
    dispatch(fetchAllWpRegistration());
  }, [dispatch]);

  const handleEdit = (row) => {
    // const client = AllClients?.data?.find(
    //   (c) => c.WhaClientName === row.WhaClientName
    // );
    const documentLink = DocumentLinks?.find(
      (d) => d.DocLinkName === row.DocLink
    );
    const whatsappSetup = WpSetupData?.find(
      (w) => w.WhatsappOffcialName === row.WhatsAppOffcialWa
    );

    // Use the rawTemplates we stored in the row
    const templateIds = row.rawTemplates?.map((t) => t._id) || [];

    setEditingData(row);
    setShowModal(true);
    setFormData({
      WhaClientName: row.WhaClientName || "",
      UserName: row.UserName || "",
      Password: row.Password,
      WhatsAppOffcialWa: whatsappSetup?._id || "",
      DocLink: documentLink?._id || "",
      Templates: templateIds,
      WhaCount: parseFloat(row.TotalBalance) || 0,
      WhaBalCount: parseFloat(row.Balance) || 0,
      IsAdmin: row.Admin === "True",
      IsActive: row.Active === "True",
      IsOWNWhatsapp: row.OwnWhatsapp === "True",
      CheckConnection: row.CheckConnection === "True",
      Database: row.Database || "",
      Port: row.Port || "",
      FolderName: row.FolderName || "",
      WappNo: row.WappNo || "",
      APIToken: row.APIToken || "",
      PhoneNoID: row.PhoneNoID || "",
      VerifyToken: row.VerifyToken || "",
      Server: row.Server || "",
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleTemplateChange = (event) => {
    const { value } = event.target;
    setFormData((prev) => ({
      ...prev,
      Templates: value,
    }));
  };

  const handleDelete = async (row) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete this registration?`
    );
    if (!isConfirmed) return;

    try {
      await dispatch(DeleteClientRegistration(row.MainId)).unwrap();
      toast.success("Data deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
      dispatch(fetchAllWpRegistration());
    } catch (error) {
      toast.error(`Failed to delete Data: ${error}`, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const handleUpdate = async () => {
    try {
      const updatedClient = {
        ...formData,
        AdminID:
          AllClients?.data?.find(
            (c) => c.WhaClientName === formData.WhaClientName
          )?._id || null,
        Templates: formData.Templates, // already array of _id
      };

      await dispatch(
        UpdateClientRegistration({
          clientId: editingData.MainId,
          updatedClient,
        })
      ).unwrap();

      toast.success("Client registration updated successfully!");
      setShowModal(false);
      dispatch(fetchAllWpRegistration());
    } catch (error) {
      toast.error(error || "Failed to update client registration.");
    }
  };

  const columns = [
    { field: "id", headerName: "No", flex: 1 },
    {
      field: "WhaClientName",
      headerName: "Client Name",
      flex: 1,
    },
    {
      field: "DocLink",
      headerName: "Document Link Main Client",
      flex: 1,
    },
    { field: "WhatsAppOffcialWa", headerName: "WP API Setup Client", flex: 1 },
    { field: "TotalBalance", headerName: "Total Balance", flex: 1 },
    { field: "Balance", headerName: "Balance", flex: 1 },
    {
      field: "Templates",
      headerName: "Templates",
      flex: 1,
      valueGetter: (params) => params.row.Templates,
    },
    { field: "Admin", headerName: "Admin", flex: 1 },
    { field: "Active", headerName: "Active", flex: 1 },
    { field: "OwnWhatsapp", headerName: "Own Whatsapp", flex: 1 },
    { field: "CheckConnection", headerName: "Check Connection", flex: 1 },

    { field: "UserName", headerName: "UserName", flex: 1 },
    { field: "Database", headerName: "Database", flex: 1 },
    { field: "Port", headerName: "Port", flex: 1 },
    { field: "FolderName", headerName: "Folder Name", flex: 1 },
    { field: "WappNo", headerName: "Whatsapp No", flex: 1 },
    { field: "APIToken", headerName: "API Token", flex: 1 },
    { field: "PhoneNoID", headerName: "Phone No ID", flex: 1 },
    { field: "VerifyToken", headerName: "Verify Token", flex: 1 },
    { field: "Server", headerName: "Server", flex: 1 },

    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <div className="flex space-x-2 justify-center">
          <button
            className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
            onClick={() => handleEdit(params.row)}
          >
            Update
          </button>
          <button
            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            onClick={() => handleDelete(params.row)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const rows = (
    Array.isArray(WpRegistrationList?.data) ? WpRegistrationList?.data : []
  )?.map((el, index) => ({
    id: index + 1,
    MainId: el._id,
    WhaClientName: el?.WhaClientName,
    DocLink: el?.DocLink?.DocLinkName,
    WhatsAppOffcialWa: el?.WhatsAppOffcialWa?.WhatsappOffcialName,
    TotalBalance: el?.WhaCount ? parseFloat(el?.WhaCount).toFixed(2) : "0.00",
    Balance: el?.WhaBalCount ? parseFloat(el?.WhaBalCount).toFixed(2) : "0.00",
    Templates: Array.isArray(el?.Templates)
      ? el.Templates.map((t) => t.FormatID).join(", ")
      : "N/A",
    Admin: el?.IsAdmin ? "True" : "False",
    Active: el?.IsActive ? "True" : "False",
    OwnWhatsapp: el?.IsOWNWhatsapp ? "True" : "False",
    CheckConnection: el?.CheckConnection ? "True" : "False",
    UserName: el?.UserName,
    Password: el?.Password,
    Database: el?.Database || "N/A",
    Port: el?.Port,
    FolderName: el?.FolderName,
    rawTemplates: el?.Templates || [],
    WappNo: el?.WappNo,
    APIToken: el?.APIToken,
    PhoneNoID: el?.PhoneNoID,
    VerifyToken: el?.VerifyToken,
    Server: el?.Server,

  }));

  if (!WpRegistrationList?.data) {
    return <Loader />;
  }

  return (
    <>
      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            View WhatsApp Registration
          </h3>
        </div>

        <div className="rounded-lg overflow-x-auto mt-2">
          <WpDynamicTable columns={columns} rows={rows} height="550px" />
        </div>

        {showModal && editingData && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2">
            <div className="bg-white rounded-lg shadow-lg p-4 w-full max-w-[95vw] md:max-w-3xl relative mx-auto max-h-[95vh] overflow-y-auto">
              <h2 className="text-xl font-bold mb-4">
                Update WhatsApp Registration
              </h2>
              <form
                onSubmit={(e) => {
                  handleUpdate();
                  setShowModal(false);
                }}
                className="grid gap-4"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Client Name
                    </label>
                    <input
                      type="text"
                      name="WhaClientName"
                      className="w-full border p-2 rounded"
                      value={formData.WhaClientName}
                      onChange={handleChange}
                      readOnly
                      placeholder="Client Name"
                    />
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Document Link
                    </label>
                    <select
                      name="DocLink"
                      value={formData.DocLink}
                      onChange={handleChange}
                      className="w-full border-2 py-2 border-black rounded"
                    >
                      <option value="">Select Document Link</option>
                      {[...(DocumentLinks || [])]
                        .sort((a, b) =>
                          (a.DocLinkName || "").localeCompare(b.DocLinkName || "")
                        )
                        .map((link) => (
                          <option key={link._id} value={link._id}>
                            {link.DocLinkName}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      WP API Setup
                    </label>
                    <select
                      name="WhatsAppOffcialWa"
                      value={formData.WhatsAppOffcialWa}
                      onChange={handleChange}
                      className="w-full border-2 py-2 border-black rounded"
                    >
                      <option value="">Select WP API Setup</option>
                      {[...(WpSetupData || [])]
                        .sort((a, b) =>
                          (a.WhatsappOffcialName || "").localeCompare(
                            b.WhatsappOffcialName || ""
                          )
                        )
                        .map((w) => (
                          <option key={w._id} value={w._id}>
                            {w.WhatsappOffcialName}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Templates
                    </label>
                    <FormControl style={{ maxWidth: "100%" }}>
                      <Select
                        labelId="templates-select-label"
                        id="Templates"
                        name="Templates"
                        multiple
                        value={formData.Templates}
                        onChange={handleTemplateChange}
                        input={
                          <OutlinedInput
                            label="Templates"
                            sx={{
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderWidth: "2px",
                                borderColor: "black",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "black",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: "black",
                              },
                            }}
                          />
                        }
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return <em>Select templates</em>;
                          }
                          const selectedTemplates = TemplateData?.filter((t) =>
                            selected.includes(t._id)
                          );
                          return selectedTemplates
                            .map((t) => `${t.FormatID}`)
                            .join(", ");
                        }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 300,
                              marginTop: 8,
                            },
                          },
                        }}
                      >
                        {[...(TemplateData || [])]
                          .sort((a, b) =>
                            (a.TemplateName || "").localeCompare(b.TemplateName || "")
                          )
                          .map((item) => (
                            <MenuItem key={item._id} value={item._id}>
                              <Checkbox
                                checked={formData.Templates.includes(item._id)}
                              />
                              <ListItemText
                                primary={`${item.FormatID} - ${item.TemplateName}`}
                              />
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      User Name
                    </label>
                    <input
                      type="text"
                      name="UserName"
                      className="w-full border p-2 rounded"
                      value={formData.UserName}
                      onChange={handleChange}
                      placeholder="User Name"
                    />
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Password
                    </label>
                    <input
                      type="text"
                      name="Password"
                      className="w-full border p-2 rounded"
                      value={formData.Password}
                      onChange={handleChange}
                      placeholder="Password"
                    />
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Total Balance
                    </label>
                    <input
                      type="number"
                      name="WhaCount"
                      className="w-full border p-2 rounded"
                      value={formData.WhaCount}
                      onChange={handleChange}
                      placeholder="Total Balance"
                      readOnly
                    />
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Balance
                    </label>
                    <input
                      type="number"
                      name="WhaBalCount"
                      className="w-full border p-2 rounded"
                      value={formData.WhaBalCount}
                      onChange={handleChange}
                      placeholder="Balance"
                      readOnly
                    />
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Database
                    </label>
                    <input
                      type="text"
                      name="Database"
                      className="w-full border p-2 rounded"
                      value={formData.Database}
                      onChange={handleChange}
                      placeholder="Database"
                    />
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Port
                    </label>
                    <input
                      type="text"
                      name="Port"
                      className="w-full border p-2 rounded"
                      value={formData.Port}
                      onChange={handleChange}
                      placeholder="Port"
                    />
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Folder Name
                    </label>
                    <input
                      type="text"
                      name="FolderName"
                      className="w-full border p-2 rounded"
                      value={formData.FolderName}
                      onChange={handleChange}
                      placeholder="Folder Name"
                    />
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Server
                    </label>
                    <input
                      type="text"
                      name="Server"
                      className="w-full border p-2 rounded"
                      value={formData.Server}
                      onChange={handleChange}
                      placeholder="Server"
                    />
                  </div>
                </div>

                {/* <div className=""></div> */}

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 mt-4">
                  <div className="form-group">
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="IsActive"
                        checked={formData.IsActive}
                        onChange={handleChange}
                        className="appearance-none w-6 h-6 border-2 border-black rounded-sm checked:bg-[#133a69] checked:border-blue-500 "
                      />
                      Active
                    </label>
                  </div>

                  <div className="form-group">
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="IsAdmin"
                        checked={formData.IsAdmin}
                        onChange={handleChange}
                        className="appearance-none w-6 h-6 border-2 border-black rounded-sm checked:bg-[#133a69] checked:border-blue-500 "
                      />
                      Admin
                    </label>
                  </div>

                  <div className="form-group">
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="IsOWNWhatsapp"
                        checked={formData.IsOWNWhatsapp}
                        onChange={handleChange}
                        className="appearance-none w-6 h-6 border-2 border-black rounded-sm checked:bg-[#133a69] checked:border-blue-500 "
                      />
                      Own WhatsApp
                    </label>
                  </div>

                  <div className="form-group">
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="CheckConnection"
                        checked={formData.CheckConnection}
                        onChange={handleChange}
                        className="appearance-none w-6 h-6 border-2 border-black rounded-sm checked:bg-[#133a69] checked:border-blue-500 "
                      />
                      Check Connection
                    </label>
                  </div>

                  {/* WhatsApp Bot Checkbox */}
                  <div className="form-group">
                    <label className="flex items-center gap-2">
                      <input
                        id="WhatsappBot"
                        type="checkbox"
                        name="WhatsappBot"
                        checked={formData.WhatsappBot || false}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setFormData((prev) => ({
                            ...prev,
                            WhatsappBot: checked,
                            ...(checked
                              ? {}
                              : {
                                WappNo: "",
                                APIToken: "",
                                PhoneNoID: "",
                                VerifyToken: "",
                              }),
                          }));
                        }}
                        className="appearance-none w-6 h-6 p-2 border-2 border-black rounded-sm checked:bg-[#133a69] checked:border-blue-500"
                      />
                      <span className="text-base font-medium">
                        Whatsapp Bot
                      </span>
                    </label>
                  </div>

                  {/* Conditional Fields */}
                  {formData.WhatsappBot && (
                    <>
                      <div className="form-group col-span-1 sm:col-span-2 lg:col-span-1">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Whatsapp No
                        </label>
                        <input
                          type="text"
                          name="WappNo"
                          className="w-full border p-2 rounded"
                          value={formData.WappNo}
                          onChange={handleChange}
                          placeholder="Wapp No"
                        />
                      </div>

                      <div className="form-group col-span-1 sm:col-span-2 lg:col-span-2">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Phone No ID
                        </label>
                        <input
                          type="text"
                          name="PhoneNoID"
                          className="w-full border p-2 rounded"
                          value={formData.PhoneNoID}
                          onChange={handleChange}
                          placeholder="Phone No ID"
                        />
                      </div>
                      <div className="form-group col-span-1 sm:col-span-2 lg:col-span-2">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          API Token
                        </label>
                        <textarea
                          type="text"
                          name="APIToken"
                          className="w-full border p-2 rounded"
                          value={formData.APIToken}
                          onChange={handleChange}
                          placeholder="API Token"
                        />
                      </div>

                      <div className="form-group">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Verify Token
                        </label>
                        <input
                          type="text"
                          name="VerifyToken"
                          className="w-full border p-2 rounded"
                          value={formData.VerifyToken}
                          onChange={handleChange}
                          placeholder="Verify Token"
                        />
                      </div>
                    </>
                  )}
                </div>

                <div className="flex justify-center mt-4">
                  <button
                    type="button"
                    onClick={() => setShowModal(false)}
                    className="mr-3 px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                  >
                    Save
                  </button>
                </div>
              </form>

              <button
                onClick={() => setShowModal(false)}
                className="absolute top-2 right-2 text-gray-500 hover:text-black text-lg"
              >
                ✖
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default View_WpRegistration;
